import React from "react";

import * as Sentry from "@sentry/react";

import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";

// intake
import { IntakeFormLayout } from "./screens/IntakeFormScreen/IntakeFormLayout";
import { IntakeFormConsentScreen } from "./screens/IntakeFormScreen/IntakeSteps/IntakeFormConsentScreen";
import { IntakeFormCaregiverInfoScreen } from "./screens/IntakeFormScreen/IntakeSteps/IntakeFormCaregiverInfoScreen";
import { IntakeFormAddressScreen } from "./screens/IntakeFormScreen/IntakeSteps/IntakeFormAddressScreen";
import { IntakeFormMemberInfoScreen } from "./screens/IntakeFormScreen/IntakeSteps/IntakeFormMemberInfoScreen";
import { IntakeFormInsuranceInfoScreen } from "./screens/IntakeFormScreen/IntakeSteps/IntakeFormInsuranceInfoScreen";
import { IntakeFormSubmitScreen } from "./screens/IntakeFormScreen/IntakeSteps/IntakeFormSubmitScreen";

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

const IntakePageRedirect: React.FC = () => {
  React.useEffect(() => {
    window.location.replace("https://www.mightier.com/intake");
  }, []);
  return null; // or a loading spinner
};

const router = sentryCreateBrowserRouter([
  {
    path: "/",
    element: <Navigate to="/intake/1" replace />,
  },
  // see here for inspiration
  // https://github.com/remix-run/react-router/blob/dev/examples/route-objects/src/App.tsx
  // "children" means that everything in the top is always rendered, but "children" are swapped by the sub url
  {
    path: "/intake",
    element: <IntakeFormLayout />,
    children: [
      {
        index: true,
        element: <IntakePageRedirect />,
      },
      {
        path: "/intake/1",
        element: <IntakeFormConsentScreen />,
      },
      {
        path: "/intake/2",
        element: <IntakeFormCaregiverInfoScreen />,
      },
      {
        path: "/intake/3",
        element: <IntakeFormAddressScreen />,
      },
      {
        path: "/intake/4",
        element: <IntakeFormMemberInfoScreen />,
      },
      {
        path: "/intake/5",
        element: <IntakeFormInsuranceInfoScreen />,
      },
      {
        path: "/intake/submit",
        element: <IntakeFormSubmitScreen />,
      },
    ],
  },
]);

export const AppNavigationContainer = React.memo(() => {
  return <RouterProvider router={router} />;
});

AppNavigationContainer.displayName = "AppNavigationContainer";
